
import caseLogo1 from "../assets/user-case/case-logo1.png"
import caseLogo3 from "../assets/user-case/case-logo1.png"
import caseLogo4 from "../assets/user-case/case-logo1.png"
import caseLogo5 from "../assets/user-case/case-logo1.png"
import caseLogo6 from "../assets/user-case/case-logo6.png"
import caseImg1 from "../assets/user-case/case-img1.png"
import caseImg2 from "../assets/user-case/case-img2.png"
import caseImg3 from "../assets/user-case/case-img3.png"
import caseImg4 from "../assets/user-case/case-img4.png"
import caseImg5 from "../assets/user-case/case-img5.png"
import caseImg6 from "../assets/user-case/case-img6.png"
import caseImg8 from "../assets/user-case/case-img8.png"
import caseImg9 from "../assets/user-case/case-img9.png"

const userCases = [
    {
        caseLogo: caseLogo1,
        title: "首都医科大学宣武医院",
        desc: ["通过慧脑云平台构建全脑白质纤维束、检测髓鞘受损区域、预测运动恢复情况。"],
        caseImg: caseImg1
    },
    {
        caseLogo: caseLogo1,
        title: "首都医科大学宣武医院",
        desc: ["通过慧脑云平台功能磁共振核心分析算法检测大脑活动异常区域。", "针对睡眠障碍相关脑区使用无创电刺激治疗显著改善睡眠质量。"],
        caseImg: caseImg2
    },
    {
        caseLogo: caseLogo3,
        title: "上海市同济医院",
        desc: ["基于慧脑云平台脑形态学分析算法，计算皮层厚度、面积、体积、曲率等。", "发现AD相关脑结构的异常改变，实现AD早期精准检测和预测。"],
        caseImg: caseImg3
    },
    {
        caseLogo: caseLogo4,
        title: "北京大学第六医院",
        desc: ["通过慧脑云核心脑影像算法，计算全脑的功能连接和结构连接。 发现精神疾病的脑网络异常，辅助精神疾病的诊断和分型。"],
        caseImg: caseImg4
    },
    {
        caseLogo: caseLogo5,
        title: "山东第一医科大学",
        desc: ["使用慧脑云平台的纤维束追踪技术，寻找衰老过程中脑白质纤维束的微观变化。"],
        caseImg: caseImg5
    },
    {
        caseLogo: caseLogo6,
        title: "首都医科大学天坛医院",
        desc: ["使用慧脑云平台核心算法，检测脑膜瘤运动区占位患者术前术后白质区域差异。", "发现患者术后的脑白质纤维束完整性受损情况得到改善。", "脑膜瘤运动区占位患者术前术后大脑结构网络对比，发现患者术后的大脑结构连接得到增强。"],
        caseImg: caseImg6
    },
    // {
    //     caseLogo: caseLogo7,
    //     title: "中国人民解放军总医院·美国麻省总医院",
    //     desc: ["采用慧脑云平台的功能影像核心算法，定量分析多种脑功能网络成分，辅助自闭症的精准分型检测。"],
    //     caseImg: caseImg7
    // },
    {
        caseLogo: caseLogo1,
        title: "首都医科大学宣武医院",
        desc: ["使用慧脑云结构影像核心算法，进行全脑组织分割和海马亚区重建，量化海马结构异常，判断癫痫发病原因。"],
        caseImg: caseImg8
    },
    {
        caseLogo: caseLogo1,
        title: "首都医科大学宣武医院",
        desc: ["使用慧脑云平台脑影像核心算法，构建和分析认知损伤患者脑网络属性。", "发现认知损伤患者经过干预训练后的脑网络改变。"],
        caseImg: caseImg9
    }
]

export default userCases;